export enum ServicePlanningTabState {
  NONE = 'NONE',
  TO_PLAN = 'TO_PLAN',
  TO_PLACE = 'TO_PLACE'
}
